/* eslint-disable react/prop-types */
import "./ShowTimelinePreview.css";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import styled from "@emotion/styled";
import { CircularProgress, Box, Divider, Tooltip } from "@mui/material";
import Chip from "@mui/material/Chip";
import Iframe from "react-iframe";
import Linkify from "react-linkify";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const StyledDialogTitle = styled(DialogTitle)`
  color: ${(props) => props.theme.palette.primary.contrastText};
  background-color: ${(props) => props.theme.palette.primary.main};
  padding: 5px 10px;
`;

const StyledButton = styled(Button)`
  color: ${(props) => props.theme.palette.primary.contrastText};
`;

const ContentContainer = styled(Box)`
  /* text-align: center; */
  margin: 20px;
  overflow-y: auto;
  max-height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledMessage = styled("div")`
  /* width: 80%; */
  max-width: 800px;
  /* margin: 0 auto; */
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  /* text-align: left; */
  display: flex;
  flex-direction: column;
  align-items: center;
`;

function ShowTimelinePreview({ open, timelineData, handleClose }) {
  const [loading, setLoading] = useState(true);
  const [article, setArticle] = useState(null); //timeline情報

  const date = new Date();

  //#region something タイムライン詳細を閉じるとき
  const handleDialogClose = () => {
    handleClose();
  };
  //  #endregion

  useEffect(() => {
    if (open && timelineData) {
      const selectedArticle = timelineData[0];
      setArticle(selectedArticle);
      setLoading(false);
    } else if (!open) {
      setLoading(true);
      setArticle(null);
    }
  }, [open, timelineData]); //最初に読み込む

  return (
    <Dialog fullScreen open={open} onClose={handleDialogClose} TransitionComponent={Transition}>
      <StyledDialogTitle id="max-width-dialog-title">
        <div className="show-member-search">
          <div className="show-member-search">プレビュー画面 {loading ? " (読込中...)" : ""}</div>
          <div className="question-title-actions">
            <StyledButton onClick={handleDialogClose} variant="outlined">
              閉じる (Esc)
            </StyledButton>
          </div>
        </div>
      </StyledDialogTitle>

      {article?.iswebview === "1" ? (
        <Iframe
          url={article.message}
          width="100%"
          height="100%"
          id=""
          className=""
          display="block"
          position="relative"
        />
      ) : (
        <ContentContainer>
          {loading ? (
            <CircularProgress />
          ) : (
            <div>
              <h1 className="flex-div">{article.title}</h1>

              <div className="flex-div">
                {article.name} -{" "}
                {date.getFullYear() +
                  "/" +
                  ((date.getMonth() % 12) + 1) +
                  "/" +
                  date.getDate() +
                  " " +
                  date.getHours() +
                  ":" +
                  (date.getMinutes() < 10 ? "0" : "") +
                  date.getMinutes()}
                <Tooltip title="既読">
                  <Chip
                    label={article.kbnname}
                    size="small"
                    color={article.kbnname === "全員" ? "black" : "primary"}
                    variant="outlined"
                    sx={{ ml: 2 }}
                  />
                </Tooltip>
              </div>

              <div className="flex-div">
                <Divider sx={{ my: 2.5, width: "800px" }} />
              </div>

              <div className="flex-div">
                <StyledMessage>
                  {article.thumbnail && (
                    <img
                      src={article.thumbnail}
                      alt={article.title}
                      style={{
                        maxWidth: "400px",
                        maxHeight: "300px",
                        margin: "0 0 20px 0",
                      }} /* styleでないと読み込まれない */
                    />
                  )}
                  <Linkify
                    componentDecorator={(decoratedHref, decoratedText, key) => (
                      <a target={`_blank`} href={decoratedHref} key={key} rel="noopener noreferrer">
                        {decoratedText}
                      </a>
                    )}
                  >
                    <div className="message-text">{article.message}</div>
                  </Linkify>
                </StyledMessage>
              </div>
            </div>
          )}
        </ContentContainer>
      )}
    </Dialog>
  );
}

export default ShowTimelinePreview;
